import { render, staticRenderFns } from "./cloze-test.vue?vue&type=template&id=d7cadf88&"
import script from "./cloze-test.vue?vue&type=script&lang=js&"
export * from "./cloze-test.vue?vue&type=script&lang=js&"
import style0 from "./cloze-test.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports